import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './store';

import App from './App.jsx';
import { ErrorFallback } from './components/ErrorBoundary/ErrorFallback.jsx';

import './assets/css/bd-style.scss';
import './assets/css/mui-styles.scss';
import './index.css';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
	<ErrorBoundary fallbackRender={ErrorFallback}>
		<Provider store={store}>
			<PersistGate persistor={persistor}>
				{/* <React.StrictMode> */}
				<App />
				{/* </React.StrictMode> */}
			</PersistGate>
		</Provider>
	</ErrorBoundary>
);
